import { lazy } from "react";

import Form from "../components/Form";
import LinkedInTag from "../components/LinkedInTag";

const Faq = lazy(() => import("../components/Faq"));

const FeaturesBenifits = lazy(() => import("../components/FeaturesBenifits"));
const AtmBranches = lazy(() => import("../components/AtmBranches"));
const FixDeposite = lazy(() => import("../components/FixDeposite"));
const DocumentRequired = lazy(() => import("../components/DocumentRequired"));
const Disclaimer = lazy(() => import("../components/disclaimer"));
const Footer = lazy(() => import("../components/Footer"));

function Home({ customADL, setCustomADL }) {
  return (
    <>
      <Form customADL={customADL} setCustomADL={setCustomADL} />
      <LinkedInTag />
      <FeaturesBenifits />
      <DocumentRequired />
      <AtmBranches />
      <FixDeposite />
      <Faq customADL={customADL} setCustomADL={setCustomADL} />
      <Disclaimer />
      <Footer customADL={customADL} setCustomADL={setCustomADL} />
    </>
  );
}

export default Home;
